import React from 'react'

const IconDriverLevel = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="11" height="11" stroke="#ADADAC" />
      <path d="M1 11L11 11" stroke="black" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export default IconDriverLevel
